import { css } from "styled-components";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { viewStyles } from "@insite/content-library/Widgets/SavedPayments/SavedPaymentsView";
import getColor from "@insite/mobius/utilities/getColor";

viewStyles.noPaymentsIconWrapper = mergeToNew(viewStyles.noPaymentsIconWrapper, {
    css: css`
        background-color: ${getColor("common.background")};
    `,
});
